import { RefObject, useEffect, useState } from "react";

interface IUseIntersectionObserver {
  target: RefObject<HTMLElement>;
}
export const useIntersectionObserver = ({
  target,
}: IUseIntersectionObserver) => {
  const [trigger, setTrigger] = useState(false);
  const [observer, setObserver] = useState<IntersectionObserver>();

  useEffect(() => {
    if (observer) observer.disconnect();
    const newObserver = new IntersectionObserver((entries) => {
      setTrigger(entries[0].isIntersecting);
    });
    newObserver.observe(target.current);
    setObserver(newObserver);
  }, []);

  return trigger;
};
